module.exports = __webpack_public_path__ + "img/contact-lukasbrolin.5014ce4c.png";